export function* trackUserSignup({ user }) {
  yield;
  try {
    // eslint-disable-next-line no-undef
    $FPROM.trackSignup(
      {
        email: user.last_known_email,
      },
      function () {},
    );
  } catch {
    /* do nothing */
  }
}
